import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  inject,
  ViewChild,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import {
  ParametersCreateModalComponent,
  Parameter,
  ParameterService,
  Business,
  BusinessService,
} from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { ToastAlertService } from '@core/index';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Cookies } from 'typescript-cookie';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, Observable, map, startWith } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
@Component({
  templateUrl: './parameter-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
})
export class ParameterPageComponent implements OnInit {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = ['name', 'value', 'description', 'options'];
  dataSource: MatTableDataSource<Parameter>;
  fielInput!: string;
  parameterList!: any;
  private dialog = inject(MatDialog);
  private parameterService = inject(ParameterService);
  private destroyRef = inject(DestroyRef);
  private alertService = inject(ToastAlertService);
  private businessId: number | null | undefined;
  private businessService = inject(BusinessService);
  public bussines: Business[] = [];
  public selectedBussines = 0;
  public selectedBussinesName = '';
  myControl = new FormControl('');
  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  constructor() {
    this.role();
    this.paginatorIntl = new MatPaginatorIntl();
    this.dataSource = new MatTableDataSource();
  }
  isRole: boolean = false;
  role() {
    const role = Cookies.get('role');
    if (role && role === 'ADMINISTRADOR') {
      this.isRole = true;
    } else {
      this.isRole = false;
    }
  }
  onOptionSelected(value: number, name: string) {
    this.selectedBussines = value;
    this.selectedBussinesName = name;
    this.myControl.setValue(this.selectedBussinesName);
    this.applyFilter();
  }

  applyFilter() {
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map(value => this._filter(value))
    );
  }

  ngOnInit(): void {
    this.getBusiness();
    // this.dataAdmin();
    const business = Cookies.get('bussinesId');

    if (business != null) {
      this.businessId = parseInt(business.toString());
      console.log('Business', this.businessId);
      this.selectedBussines = this.businessId;
      this.loadParameters();
    } else {
      this.businessId = null;
      //this.loadParameterGeneral();
      this.selectedBussines = 0;
    }
  }
  dataAdmin() {
    const business = Cookies.get('bussinesId');
    const idROle = Cookies.get('role');
    if (idROle === 'ADMINISTRADOR') {
      if (business != null) {
        this.businessId = parseInt(business.toString());
        console.log('Business', this.businessId);
        this.selectedBussines = this.businessId;
        this.loadParameters();
      } else {
        this.businessId = null;
        this.loadParameterGeneral();
        this.selectedBussines = 0;
      }
    }
  }

  removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private previousSearchValue: string | null = null;
  private _filter(value: string | null): Business[] {
    const filterValue = (value || '').toLowerCase();
    // Actualiza el valor de búsqueda anterior
    if (!filterValue) {
      return this.bussines;
    }
    return this.bussines.filter(
      bussines =>
        this.removeDiacritics(bussines.name.toLowerCase()).includes(
          this.removeDiacritics(filterValue)
        ) ||
        (bussines.idBusiness !== undefined &&
          bussines.idBusiness.toString().includes(filterValue))
    );
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  searchValue = new BehaviorSubject<string>('');
  onSearchInputChange(value: string | null) {
    if (value !== null && value !== undefined) {
      const searchValue = value.toString();
      this.searchValue.next(searchValue);
      this.previousSearchValue = null;
    }
  }

  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          }
        },
      });
  }

  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }
  loadParameterGeneral() {
    this.parameterService
      .getParametersGeneral()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(resp.reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            if (this.paginator) {
              this.paginator._intl.itemsPerPageLabel = 'Registros por página';
              this.paginator._intl.nextPageLabel = 'Página siguiente ';
              this.paginator._intl.previousPageLabel = 'Página anterior';
              this.paginator._intl.firstPageLabel = 'Primera página';
              this.paginator._intl.lastPageLabel = 'Última página';
              // Configuración del texto de la última página
              this.paginator._intl.getRangeLabel = (
                page: number,
                pageSize: number,
                length: number
              ) => {
                if (length === 0 || pageSize === 0) {
                  return `0 de ${length}`;
                }
                length = Math.max(length, 0);
                const startIndex = page * pageSize;
                const endIndex =
                  startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;
                return `${startIndex + 1} - ${endIndex} de ${length}`;
              };
            }
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  loadParameters() {
    if (this.selectedBussines === null) {
      this.loadParameterGeneral();
    } else {
      this.parameterService
        .getParameters(this.selectedBussines)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (resp: any) => {
            if (resp.code === 10000) {
              this.dataSource = new MatTableDataSource(resp.reply);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              if (this.paginator) {
                this.paginator._intl.itemsPerPageLabel = 'Registros por página';
                this.paginator._intl.nextPageLabel = 'Página siguiente ';
                this.paginator._intl.previousPageLabel = 'Página anterior';
                this.paginator._intl.firstPageLabel = 'Primera página';
                this.paginator._intl.lastPageLabel = 'Última página';
                // Configuración del texto de la última página
                this.paginator._intl.getRangeLabel = (
                  page: number,
                  pageSize: number,
                  length: number
                ) => {
                  if (length === 0 || pageSize === 0) {
                    return `0 de ${length}`;
                  }
                  length = Math.max(length, 0);
                  const startIndex = page * pageSize;
                  const endIndex =
                    startIndex < length
                      ? Math.min(startIndex + pageSize, length)
                      : startIndex + pageSize;
                  return `${startIndex + 1} - ${endIndex} de ${length}`;
                };
              }
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  modalAction(action?: Parameter) {
    const dialogActionDetail = this.dialog.open(
      ParametersCreateModalComponent,
      {
        width: '50%',
        data: {
          action: action,
          businessId: this.selectedBussines,
        },
        disableClose: true,
      }
    );
    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          const business = Cookies.get('bussinesId');
          if (business !== null) {
            this.loadParameters();
          } else {
            this.loadParameterGeneral();
          }
        }
      });
  }
}
